<template>
  <el-dialog
    title
    :visible.sync="centerDialogVisible"
    width="600px"
    center
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="successContent">
      <!-- 2,6团队支付方式判断是否需要审核 -->
      <div v-if="(form.prepaidPayment == 2 || form.prepaidPayment == 6) && form.paymentAudit == 1">
        <div class="successName">预约申请成功</div>
        <div class="desc">恭喜您已经成功提交预约申请，请耐心等待团长或团队管理员审核预约单信息</div>
      </div>
      <div v-else>
        <div class="successName">预约成功</div>
        <div class="desc">恭喜您已经预约成功，请耐心等待技术顾问与您一对一进行沟通</div>
      </div>
      <div class="desc">扫码关注公众号，实时掌握订单进度</div>
      <img class="qrCode" src="https://pstatic.navi-sci.cn/order/gzh_qrCode.jpg" alt="">
    </div>
    <div slot="footer" class="footerBox1">
      <div class="footerButton">
        <el-button type="primary" plain @click="toIndex()">返回首页</el-button>
        <el-button type="primary" @click="toGoods()">查看订单</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>

export default {
  props: {
    form: {
      type: [Array, Object],
      default: () => { }
    }
  },
  data() {
    return {
      centerDialogVisible: false
    };
  },
  methods: {
    init() {
      this.centerDialogVisible = true;
      this.$nextTick(() => {});
    },
    toIndex() {
    this.$router.push({path: "/",});
    },
    toGoods() {
      this.$router.push({
        path: "/aboutUsIndex",
        query: { type: 13, tabIndex: "2-1", tabName: "我的订单" }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.successContent {
  text-align: center;
}
.footerBox1 {
  width: 50%;
  margin: 0 auto;
}
.footerButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.successName {
  font-size: 24px;
  font-weight: 500;
}
.desc {
  margin: 10px 0;
}
.qrCode {
  width: 300px;
  height: 300px;
  border: 1px solid #E8E8E8;
}
</style>